import React from 'react';
import PropTypes from 'prop-types';

import Profile from './components/Profile';
import BankAccount from './components/BankAccount';

import './style.css';

export const AccountContainer = () => {
  return (
    <section className="fullPageContainer">
      <h2 styleName="header">Profile</h2>
      <Profile />
      <h2 styleName="header">Bank Account</h2>
      <BankAccount />
    </section>
  );
};

AccountContainer.propTypes = {};

export default AccountContainer;



// WEBPACK FOOTER //
// ./web/flows/account/index.js